import { ca } from '@cian/analytics';
import { TRequestCallbackOpener } from '../../../types/requestCallback';

interface IUser {
  userId?: number;
  extra?: {
    [key: string]: string | number | boolean;
  };
}

interface ITrackCallbackPopupOpenParams {
  label: string;
  placeType: TRequestCallbackOpener;
  user?: IUser;
}

export function trackSendCallbackRequest({ label, placeType, user }: ITrackCallbackPopupOpenParams) {
  ca('eventSite', {
    action: `CallBack_popup_send_${placeType}`,
    category: 'CardJK',
    label,
    name: 'oldevent',
    useLastProducts: true,
    user,
  });
}
